module.exports = __webpack_public_path__ + "img/CM-SL-24-Nissan-Modern.d6422a10.jpg";